// extracted by mini-css-extract-plugin
export default {"p_tye":"_77cc88989e","slcted":"f341a9e1b9","slc_color":"_2b75b00c00","item_p":"_235eec930c","r0":"fa43bfa3e2"};